import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import styles from './App.module.css';
import Home from './components/pages/Home';
import WhatWeDo from './components/pages/WhatWeDo';
import About from './components/pages/About';
import ScrollToTop from './components/ScrollTop';
import { usePageTracking } from './hooks/usePageTracking';

function AppContent() {
  usePageTracking();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const videoElement = document.createElement('video');
    videoElement.src = '/videos/home1.mp4';
    videoElement.preload = 'auto';

    let isMounted = true;

    const handleLoaded = () => {
      if (isMounted) {
        setIsLoading(false);
        setTimeout(() => {
          const initialLoader = document.getElementById('initial-loader');
          if (initialLoader) {
            initialLoader.style.opacity = '0';
            setTimeout(() => { initialLoader.style.display = 'none'; }, 500);
          }
        }, 100);
      }
    };

    const onCanPlay = () => handleLoaded();
    videoElement.addEventListener('canplaythrough', onCanPlay);
    videoElement.load();

    const timeout = setTimeout(handleLoaded, 5000);

    return () => {
      isMounted = false;
      videoElement.removeEventListener('canplaythrough', onCanPlay);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className={`${styles['app-container']} ${isLoading ? styles['loading'] : styles['loaded']}`}>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route path="/about" element={<About />} />
        {/* legacy routes — redirect to the new equivalents */}
        <Route path="/team" element={<Navigate to="/about" replace />} />
        <Route path="/contact" element={<Navigate to="/about" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
